import moment from 'moment';
import _ from 'lodash';

export const TASKLIST_START_DATE = moment()
  .subtract(3, 'months')
  .startOf('day');
export const TASKLIST_END_DATE = moment().endOf('day');

export const statusOptions = [
  {
    key: 'NOT_STARTED',
    value: 'NOT_STARTED',
    label: 'Aloittamatta',
    payload: ['ORDERED', 'APPROVED', 'ACKNOWLEDGED', 'ASSIGNED'],
  },
  {
    key: 'IN_PROGRESS',
    value: 'IN_PROGRESS',
    label: 'Keskeneräiset',
    payload: ['IN_PROGRESS', 'DELIVERED'],
  },
  {
    key: 'PAST',
    value: 'PAST',
    label: 'Menneet',
    payload: ['COMPLETED', 'CANCELED', 'DELEGATED', 'FAILED'],
  },
];

export const sortOptions = [
  // {
  //   key: 'LAST_UPDATED',
  //   label: 'Viimeksi päivitetty',
  //   value: 'LAST_UPDATED',
  // },
  {
    key: 'ORDER_TIME',
    label: 'Tilausaika',
    value: 'ORDER_TIME',
  },
  {
    key: 'TARGET_TIME',
    label: 'Arvioitu toimitusaika',
    value: 'TARGET_TIME',
  },
];

const initialState = {
  updateTasks: false,
  isFetchingTasks: false,
  showConfirmationModal: false,
  showNotification: false,
  notificationText: '',
  notificationHeader: '',
  approvableCount: null,
  spaces: [],
  taskData: null,
  pageOffset: 0,
  showConfirmationCompleteModal: false,
  onlyOwn: false,
  isSearched: false,
  transferTasks: [],

  category: null, // Replaced
  multiCategory: null, // Replaced
  status: [statusOptions[0].value, statusOptions[1].value],
  sort: sortOptions[0],
  unit: null, // Replaced
  costCenter: null, // Replaced
  searchTerm: '',
  startDate: TASKLIST_START_DATE,
  endDate: TASKLIST_END_DATE,
  advanced: false,
  initialized: false,
};

// eslint-disable-next-line default-param-last
export default function update(state = initialState, action) {
  switch (action.type) {
    case 'ORDER_CANCELED':
      return { ...state, updateTasks: true, showConfirmationModal: false };
    case 'ORDER_COMPLETED':
      return {
        ...state,
        updateTasks: true,
        showConfirmationCompleteModal: false,
      };
    case 'TASKLIST_FETCHED': {
      if (action.payload.isApprover && action.payload.status === 'ORDERED') {
        return {
          ...state,
          transferTasks: action.payload.data.content,
          paging: _.omit(action.payload.data, 'content'),
          taskData: action.payload.data,
          isFetchingTasks: false,
          updateTasks: false,
          lastUpdated: moment(),
        };
      }

      return {
        ...state,
        transferTasks: action.payload.data.content,
        paging: _.omit(action.payload.data, 'content'),
        taskData: action.payload.data,
        isFetchingTasks: false,
        updateTasks: false,
        lastUpdated: moment(),
      };
    }
    case 'CONFIRM_CANCEL':
      return {
        ...state,
        selectedOrderId: action.payload,
        showConfirmationModal: true,
        action: 'CANCEL',
      };
    case 'CLOSE_CONFIRMATION':
      return { ...state, showConfirmationModal: false };
    case 'CONFIRM_COMPLETE':
      return {
        ...state,
        selectedOrderId: action.payload,
        showConfirmationCompleteModal: true,
        action: 'COMPLETE',
      };
    case 'CLOSE_CONFIRMATION_COMPLETE':
      return { ...state, showConfirmationCompleteModal: false };
    case 'HIDE_NOTIFICATION':
      return {
        ...state,
        showNotification: initialState.showNotification,
        notificationText: initialState.notificationText,
        notificationHeader: initialState.notificationHeader,
      };
    case 'UPDATE_TASKS': {
      return { ...state, updateTasks: true, isFetchingTasks: true };
    }
    case 'ORGANIZATION_SET':
      return { ...state, updateTasks: true, isFetchingTasks: true };
    case 'RECEIVE_SPACES':
      return { ...state, spaces: action.payload };
    case 'POSTED_MESSAGE':
      return {
        ...state,
        showNotification: true,
        notificationText:
          'Käsittelemme sen mahdollisimman pian ja olemme tarvittaessa sinuun yhteydessä.', // eslint-disable-line
        notificationHeader: 'Kiitos palautteesta!',
      };
    case 'ORDER_APPROVED':
      return { ...state, isFetchingTasks: true, updateTasks: true };
    case 'SET_IS_SEARCHED': {
      return { ...state, isSearched: action.payload };
    }
    case 'TOGGLE_ONLY_OWN': {
      return { ...state, onlyOwn: !state.onlyOwn };
    }
    case 'ABORT_FETCHING_TASKS': {
      return { ...state, isFetchingTasks: false, updateTasks: false };
    }
    case 'SET_FETCHING_TASKS': {
      return { ...state, isFetchingTasks: action.payload };
    }
    case 'SET_PAGE_OFFSET': {
      return { ...state, pageOffset: action.payload };
    }
    case 'SET_SEARCH_TERM': {
      return { ...state, searchTerm: action.payload };
    }
    case 'SET_START_DATE': {
      return { ...state, startDate: action.payload };
    }
    case 'SET_END_DATE': {
      return { ...state, endDate: action.payload };
    }
    case 'SET_ADVANCED': {
      return { ...state, advanced: action.payload };
    }
    case 'SET_CATEGORY': {
      return { ...state, category: action.payload };
    }
    case 'SET_MULTI_CATEGORY': {
      return { ...state, multiCategory: action.payload };
    }
    case 'SET_STATUS': {
      return { ...state, status: action.payload };
    }
    case 'SET_SORT': {
      return { ...state, sort: action.payload };
    }
    case 'SET_UNIT': {
      return { ...state, unit: action.payload };
    }
    case 'SET_COST_CENTER': {
      return { ...state, costCenter: action.payload };
    }
    // case 'SET_INITIALIZED': {
    //   return { ...state, initialized: action.payload };
    // }
    case 'RESET_FILTERS': {
      return {
        ...state,
        category: null, // Replaced
        multiCategory: null, // Replaced
        status: [statusOptions[0].value, statusOptions[1].value],
        sort: sortOptions[0],
        unit: null, // Replaced
        costCenter: null, // unit is the default choice
        searchTerm: '',
        startDate: TASKLIST_START_DATE,
        endDate: TASKLIST_END_DATE,
        advanced: false,
        initialized: false,
      };
    }
    default:
      return state;
  }
}
